// Release notes for VBLive.
//
// To add a new release: copy an entry below, put it anywhere in the array
// (order does not matter — entries are sorted by version, newest first, on the
// Information page), set the `version` and `date`, and list the `notes`.
//
//   {
//     version: "1.1.0",
//     date: "2026-07-01",
//     notes: [
//       "Short description of a change.",
//       "Another change.",
//     ],
//   },

export const releaseNotes = [
  {
    version: "1.0.0",
    date: "2026-06-13",
    notes: [
      "Live-code volleyball matches and import DataVolley (.dvw) and VBStats files.",
      "Dashboard, Box Score, hitting charts, serve-receive and sideout reports.",
      "AI Reports and AI Coach provide written analysis of team and player performance.",
      "Choose your rotation naming convention (R1–R6 or setter position) in Settings; it is used consistently across all reports.",
      "Available in 16 languages with a built-in Translation Editor.",
    ],
  },
  {
    version: "1.0.1",
    date: "2026-06-15",
    notes: [
      "Make sure rotations are always displayed using the selected naming convention (R1–R6 or setter position) across all reports, including the Rotation filter in the Matches page.",
    ],
  },
  {
    version: "1.0.2",
    date: "2026-06-16",
    notes: [
      "Sneak-peeks of the upcoming Match Coding feature and AI Reports available in many languages.",
      "The new features will be available for subscribers in the next few weeks, starting with early access for beta testers.",
    ],
  },
  {
    version: "1.0.3",
    date: "2026-06-29",
    notes: [
      "Fixed a bug where importing a DVW file of a match between two teams with the same name would overwrite the existing match in the database.",
      "Option to save newly imported match to database."
    ],
  },
  {
    version: "1.0.4",
    date: "2026-06-30",
    notes: [
      "Fixed Share window not showing.",
    ],
  },
  {
    version: "1.0.5",
    date: "2026-07-01",
    notes: [
      "Added ability to see who has viewed a shared match.",
      "Improved playlists functionality including ability to assign playlists to a team or player (Pro version only).",
      "Added ability to save AI Reports to a team or player (Pro version only).",
      "Added ability to merge teams with same roster players from imported matches by different scouts at the same tournament (Pro version only)."
    ],
  },
  {
    version: "1.0.6",
    date: "2026-07-01",
    notes: [
      "Fixed bugs when importing VBStats files",
      "Added ability to receive broadcast from a live VBStats match.",
      "Fixed issues with Filters on Video Analysis screen.",
      "Fixed scrolling issues on Box Score screen.",
      "Fixed match scores in Match Centre report when a match is imported from a VBStats file.",
      "Added ability to receive live broadcast from local network (LAN).",
    ],
  },
  {
    version: "1.0.7",
    date: "2026-08-01",
    notes: [
      "Fixed videos losing synch",
    ],
  },
  {
    version: "1.0.8",
    date: "2026-10-11",
    notes: [
      "Added support for VolleyStation VSM files.",
      "Added support for Power Play in Australian Super Volleyball League.",
    ],
  },
  {
    version: "1.0.9",
    date: "2026-10-12",
    notes: [
      "Improved Play List viewer for phone screens."
    ],
  },
  {
    version: "1.0.10",
    date: "2026-10-13",
    notes: [
      "Added Momentum Chart."
    ],
  },
  {
    version: "1.0.11",
    date: "2026-10-14",
    notes: [
      "Added Serve Receives by Zones analysis."
    ],
  },
  {
    version: "1.0.12",
    date: "2026-10-15",
    notes: [
      "Added Advanced Video Analysis Filters page."
    ],
  },
  {
    version: "1.0.13",
    date: "2026-10-16",
    notes: [
      "Added ability to share AI reports.",
      "Added ability to send email notifications when sharing."
    ],
  },
  {
    version: "1.0.14",
    date: "2026-10-17",
    notes: [
      "Added Catapult Focus integration for jump analysis."
    ],
  },
  {
    version: "1.0.15",
    date: "2026-10-18",
    notes: [
      "Added support for VolleyStation VSS files."
    ],
  },
];

// Compare two semantic version strings (e.g. "1.2.0"). Returns > 0 when a is
// newer than b, < 0 when older, 0 when equal. Missing/extra segments and
// non-numeric parts are handled gracefully.
export const compareVersions = (a, b) => {
  const pa = String(a).split(".").map((n) => parseInt(n, 10) || 0);
  const pb = String(b).split(".").map((n) => parseInt(n, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (var i = 0; i < len; i++) {
    const da = pa[i] || 0;
    const db = pb[i] || 0;
    if (da !== db) {
      return da - db;
    }
  }
  return 0;
};

// Release notes sorted newest version first.
export const sortedReleaseNotes = () =>
  [...releaseNotes].sort((a, b) => compareVersions(b.version, a.version));
